// Retry function to help reduce the frequency of chunk load issues occurring and the instances recorded in Sentry.
import { ComponentType } from 'react';
import { USER_CONTINENT, USER_COUNTRY } from '@whitelabel/helpers/constants';
import api, { API_HOST } from './api';

// eslint-disable-next-line import/prefer-default-export
export const retry = (
  fn: (...args: any[]) => any,
  retriesLeft = 5,
  interval = 1000,
): Promise<{ default: ComponentType<any> }> => {
  return new Promise((resolve, reject) => {
    fn()
      .then(resolve)
      .catch((error: any) => {
        setTimeout(() => {
          if (retriesLeft === 1) {
            reject(error);
            return;
          }
          retry(fn, retriesLeft - 1, interval).then(resolve, reject);
        }, interval);
      });
  });
};

export async function storeUserGeoIpInfo(): Promise<void> {
  try {
    const { countryCode, continentCode } = await api.get(`${API_HOST}/geoip/`, false);
    if (countryCode) {
      sessionStorage.setItem(USER_COUNTRY, countryCode);
    }
    if (continentCode) {
      sessionStorage.setItem(USER_CONTINENT, continentCode);
    }
  } catch {
    // ignore geoip error
  }
}
